module.exports = __webpack_public_path__ + "img/Transpordiamet_logo_sinine_est.696b22a3.svg";